export enum AssessmentWithSeverityActionReference {
  DEFAULT = 'DEFAULT',
  ORGANIZATION = 'ORGANIZATION',
  CHECKLIST = 'CHECKLIST',
}
